import { useResources } from 'datx-jsonapi-react';
import { FC, Fragment, ReactNode } from 'react';

import { NoTicket } from '@/components/ui/shared/overlays/NoTicketCheck/components/NoTicket';
import { NoTicketSkeleton } from '@/components/ui/shared/overlays/NoTicketCheck/components/NoTicketSkeleton';
import { UserNotLoggedIn } from '@/components/ui/shared/overlays/NoTicketCheck/components/UserNotLoggedIn';
import useSession from '@/hooks/useSession';
import { queryEventTicketForUser } from '@/queries/event-tickets';
import { ThinEvent } from '@/resources/ThinEvent';

interface INonPublicTicketCheck {
  event: ThinEvent;
  children: ReactNode;
}

export const NonPublicTicketCheck: FC<INonPublicTicketCheck> = ({ event, children }) => {
  const { user, isSessionLoading } = useSession();

  const { data: tickets, error: ticketsError } = useResources(queryEventTicketForUser(event?.id, user?.id));

  const isNoTicket = !tickets && !ticketsError;

  if (isSessionLoading) {
    return <NoTicketSkeleton />;
  }

  if (!user?.id) {
    return <UserNotLoggedIn event={event} />;
  }
  if (tickets?.length === 0) {
    return <NoTicket event={event} />;
  }
  if (isNoTicket) {
    return <NoTicketSkeleton />;
  }

  return <Fragment>{children}</Fragment>;
};
